module.exports = __webpack_public_path__ + "media/images/icon-svg/search-white-6950d90f4a62d9ddc2f5ddc337260c32.svg";